import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const ManipulationString = () =>{
    function calcHeight(nbLine){
        let calc = 19*nbLine
        return calc+"px"
        }
    return(
    
        <div id="articleContent" className="ManipulationString">
        
        <h2>Les propriétés et les méthodes</h2>
                    
                    <table class="propsJavascript">
                        <tr>
                            <td colspan="3">Capturer la longueur d'une chaîne</td>
                        </tr>
                        <tr>
                            <td>.length</td>
                            <td>
                             <pre><code>
      <AceEditor
      height={calcHeight(3)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`const message = 'mon message';
console.log(message.length);
// expected output: 11</div>`}/>
      </code>
      </pre>
                        </td>
                            <td>Elle décrit le contenu actuel de la chaîne. Elle n'est donc pas modifiable par le code. On dit qu'elle est acessible en lecture seule</td>
                        </tr>
                        <tr>
                            <td colspan="3">Modifier majuscules et minuscules</td>
                        </tr>
                        <tr>
                            <td>.toUpperCase()</td>
                            <td>
                            <pre>
      <code>
      <AceEditor
      height={calcHeight(3)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`let message = "Mon Message"
console.log(message.toUpperCase())
// expected output : MON MESSAGE`}
        />
      </code>
      </pre>
                            </td>
                            <td>Modifie la casse pour la mettre en majuscule</td>
                        </tr>
                        <tr>
                            <td>.toLowerCase()</td>
                            <td> <pre><code><AceEditor
      height={calcHeight(3)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`let message = "Mon Message"
console.log(message.toLowerCase())
// expected output : mon message</div> `}
        />
      </code>
      </pre></td>
                            <td>Modifie la casse pour la mettre en minuscule</td>
                        </tr>
                        <tr>
                            <td colspan="3">Nettoyer une chaîne</td>
                        </tr>
                        <tr>
                            <td>.trim()</td>
                            <td> <pre><code><AceEditor
      height={calcHeight(4)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`let message = "   Mon Message   "
console.log(message.trim())
// expected output : "Mon Message"</div> `}
        />
      </code>
      </pre></td>
                            <td>Nettoie la  chaîne de ses caractères inutiles en début et en fin en supprimant les espaces, tabulations et retour chariot</td>
                        </tr>
                        <tr>
                            <td colspan="3">Accéder à un caractère précis</td>
                        </tr>
                        <tr>
                            <td>.charAt(indice)</td>
                            <td> <pre><code><AceEditor
      height={calcHeight(3)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`let message = "loremipsum"
console.log(message.charAt(2))
//expected output : r</div>`}
        />
      </code>
      </pre></td>
                            <td>Retourne le caractère à la position <em>indice</em></td>
                        </tr>
                        <tr>
                            <td>.charCodeAt(indice)</td>
                            <td> <pre><code><AceEditor
      height={calcHeight(3)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`let message = "loremipsum"
console.log(message.charCodeAt(2))
//expected output : 114</div>`}
        />
      </code>
      </pre></td>
                            <td>Retourne le code ASCII du caractère à la position <em>indice</em></td>
                        </tr>
                        <tr>
                            <td colspan="3">Rechercher dans une chaîne</td>
                        </tr>
                        <tr>
                            <td>.lastIndexOf(chaine, indice)</td>
                            <td> <pre><code><AceEditor
      height={calcHeight(9)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var message = "Lorem ipsum dolor"
console.log(message.lastIndexOf("r"))
//expected output : 16
console.log(message.lastIndexOf("ip"))
//expected output : 6
console.log(message.lastIndexOf("wo"))
//expected output : -1
console.log(message.lastIndexOf("m",8))
//expected output : 4</div> `}
        />
      </code>
      </pre></td>
                            <td>Retourne l'indice de la dernière sous-chaîne trouvée dans chaine (-1 si aucune sous chaîne trouvée et comptage à partir de 0)</td>
                        </tr>
                        
                        <tr>
                            <td>.indexOf(chaine, indice)</td>
                            <td><pre><code> <AceEditor
      height={calcHeight(9)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var message = "Lorem ipsum dolor"
console.log(message.indexOf("r"))
//expected output : 16
console.log(message.indexOf("ip"))
//expected output : 6
console.log(message.indexOf("wo"))
//expected output : -1
console.log(message.indexOf("m",5))
//expected output : 10</div>`}
        />
      </code>
      </pre></td>
                            <td>Retourne l'indice de la sous-chaîne trouvée dans chaine à partir d'un indice de début facultatif (-1 si aucune sous chaîne trouvée et comptage à partir de 0)</td>
                        </tr>
                        <tr class="pageBreak">
                        <td height="80px"></td>
                        <td></td>
                        <td></td>
                    </tr>

                        <tr>
                            <td colspan="3">Extraire une sous-chaîne</td>
                        </tr>
                        <tr>
                            <td>.substring(indiceDebut, indiceFin)</td>
                            <td><pre><code><AceEditor
      height={calcHeight(3)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var message = "Lorem ipsum dolor"
console.log(message.substring(1,5))
//expected output : orem</div>`}
        />
      </code>
      </pre></td>
                            <td>Attend un second paramètre facultatif correspondant à l'indice de fin de la sous-chaîne à retourner. Si l'indice de fin n'est pas précisé, la sous-chaîne se poursuit jusqu'à la fin de la chaîne d'origine</td>
                        </tr>
                        <tr>
                            <td>.substr(indice, longueur)</td>
                            <td><pre><code><AceEditor
      height={calcHeight(3)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var message = "Lorem ipsum dolor"
console.log(message.substr(1,7))
//expected output : orem ip</div>`}
        />
      </code>
      </pre></td>
                            <td>Attend en second paramètre obligatoire la longueur de la sous-chaîne à extraire</td>
                        </tr>
                        <tr>
                            <td colspan="3">Compléter une chaîne</td>
                        </tr>
                        
                        <tr>
                            <td>.padStart(longueur, string)</td>
                            <td><pre><code><AceEditor
      height={calcHeight(7)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var message = "Lorem ipsum dolor"
console.log(message.padStart(message.length+5,"*"))
//expected output : *****Lorem ipsum dolor
var message = '555';
console.log(message.padStart(5, '*'))
//expected output : **555</div>`}
        />
      </code>
      </pre></td>
                            <td>Retourne une chaîne d'entrée garnie avec une série de caractères au début afin d'atteindre une longueur totale voulue</td>
                        </tr>

                        <tr>
                            <td>.padEnd(longueur, string)</td>
                            <td><pre><code><AceEditor
      height={calcHeight(7)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var message = "Lorem ipsum dolor"
console.log(message.padEnd(message.length+5,"."))
//expected output : Lorem ipsum dolor.....
var message = '555';
console.log(message.padEnd(5, '.'))
//expected output : 555..</div> `}
        />
      </code>
      </pre></td>
                            <td>Retourne une chaîne d'entrée garnie avec une série de caractères à la fin afin d'atteindre une longueur totale voulue</td>
                        </tr>
                        
                        <tr>
                            <td colspan="3">Traitement des caractères spéciaux</td>
                        </tr>

                      
                        
                        <tr>
                            <td>.fromCharCode()</td>
                            <td><pre><code><AceEditor
      height={calcHeight(2)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`console.log(String.fromCharCode(189, 43, 190, 61));
// expected output: "½+¾="</div>`}
        />
      </code>
      </pre></td>
                            <td>Retourne une chaîne de caractères formée des codes ASCII passés en paramètres</td>
                        </tr>
                        
                        <tr>
                            <td>.encodeURIComponent()</td>
                            <td><pre><code><AceEditor
      height={calcHeight(11)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var uri = 'https://mozilla.org/?x=шеллы';
var encoded = encodeURI(uri);
console.log(encoded);
// expected output: "https://mozilla.org/?x=%D1%88%D0%B5%
//D0%BB%D0%BB%D1%8B"
try {
    console.log(decodeURI(encoded));
    // expected output: "https://mozilla.org/?x=шеллы"
} catch (e) { // catches a malformed URI
    console.error(e);}</div>`}
        />
      </code>
      </pre></td>
                            <td>Réalise la chaîne passée en paramètre encodée</td>
                        </tr>
                        
                        <tr>
                            <td>.decodeURIComponent()</td>
                            <td><pre><code><AceEditor
      height={calcHeight(10)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`function containsEncodedComponents(x) {
// ie ?,=,&,/ etc
return (decodeURI(x) !== decodeURIComponent(x));
}
console.log(containsEncodedComponents('%3Fx%3Dtest')); // ?x=test
// expected output: true
console.log(containsEncodedComponents('%D1%88%D0%B5%D0%BB%D0%BB%D1%8B')); 
// шеллы
// expected output: false</div>`}
        />
      </code>
      </pre></td>
                            <td>Réalise l'opération inverse</td>
                        </tr>

                        <tr>
                            <td colspan="3">Exécuter une chaîne Javascript</td>
                        </tr>
                        <tr>
                            <td>.eval()</td>
                            <td><pre><code><AceEditor
      height={calcHeight(9)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`console.log(eval('2 + 2'));
// expected output: 4
console.log(eval(new String('2 + 2')));
// expected output: 2 + 2
console.log(eval('2 + 2') === eval('4'));
// expected output: true
console.log(eval('2 + 2') === eval(new String('2 + 2')));
// expected output: false</div>`}/>
      </code>
      </pre></td>
                            <td>Exécute la chaîne Javascript passé en paramètre et retourne son résultat éventuel</td>
                        </tr>
                        <tr>
                            <td>new RegExp(String motif[,String option])</td>
                            <td><pre><code><AceEditor
      height={calcHeight(8)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var regex1 = /\w+/;
var regex2 = new RegExp('\\w+');
console.log(regex1);
// expected output: /\w+/
console.log(regex2);
// expected output: /\w+/
console.log(regex1 === regex2);
// expected output: false</div> `}
        />
      </code>
      </pre></td>
                            <td>Le paramètre motif est une chaîne decaractères contenant le "programme" de l'expression régulière. Le paramètre option est facultatif.Voir le cours sur les Regex</td>
                        </tr>
                        <tr>
                            <td>reg.test()</td>
                            <td><pre><code><AceEditor
      height={calcHeight(14)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var str = 'table football';
var regex = new RegExp('foo*');
var globalRegex = new RegExp('foo*', 'g');
console.log(regex.test(str));
// expected output: true
console.log(globalRegex.lastIndex);
// expected output: 0
console.log(globalRegex.test(str));
// expected output: true
console.log(globalRegex.lastIndex);
// expected output: 9
console.log(globalRegex.test(str));
// expected output: false</div>`}
        />
      </code>
      </pre></td>
                            <td>Retourne vrai ou faux selon que chaine satisfait au motif de reg</td>
                        </tr>
                        <tr>
                            <td>reg.exec()</td>
                            <td> <pre><code>
      <AceEditor
      height={calcHeight(8)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var regex2 = RegExp('foo*', 'g');
var str1 = 'table football, foosball';
var array1;
while ((array1 = regex2.exec(str1)) !== null) {
    console.log('Found' + array1[0]'.'+ 'Next starts at' + regex2.lastIndex + '.');
    // expected output: "Found foo. Next starts at 9."
    // expected output: "Found foo. Next starts at 19."`}/>
      </code>
      </pre></td>
                            <td>Retourne la première sous-chaîne de chaîne correspondant au motif reg</td>
                        </tr>
                        <tr>
                            <td colspan="3">Recherche et remplacement de motifs</td>
                        </tr>
                        <tr>
                            <td>.search()</td>
                            <td><pre><code><AceEditor
      height={calcHeight(8)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var paragraph = 'The quick brown fox jumps over the lazy dog. Blabla';
// any character that is not a word character or whitespace
var regex3 = /[^\w\s]/g;
console.log(paragraph.search(regex3));
// expected output: 43
console.log(paragraph[paragraph.search(regex3)]);
// expected output: "."</div>`}
        />
      </code>
      </pre></td>
                            <td>Retourne le premier indice de caractère correspondant à RegExp</td>
                        </tr>
                        <tr>
                            <td>.replace()</td>
                            <td><pre><code><AceEditor
      height={calcHeight(7)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var p = 'The quick brown fox jumps over the lazy dog.';
console.log(p.replace('dog', 'monkey'));
// expected output: "The quick brown fox jumps over the lazy monkey."
var regex = /Dog/i;
console.log(p.replace(regex, 'ferret'));
// expected output: "The quick brown fox jumps over the lazy ferret."</div> `}
        />
      </code>
      </pre></td>
                            <td>Trouve et remplace par une chaîne de remplacement les occurences répondant aux critères d'une RegExp</td>
                        </tr>
                        <tr>
                            <td>.match()</td>
                            <td><pre><code><AceEditor
      height={calcHeight(6)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var paragraph = 'The quick brown fox jumps over the lazy dog. It barked.';
var regex = /[A-Z]/g;
var found = paragraph.match(regex);
console.log(found);
// expected output: Array ["T", "I"]</div>`}/>
      </code>
      </pre></td>
                            <td>Retourne dans un tableau toutes les occurences répondant aux critères d'une RegExp</td>
                        </tr>
                        <tr>
                            <td>.split()</td>
                            <td> <pre><code>
      <AceEditor
      height={calcHeight(11)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`var str = 'The quick brown fox jumps over the lazy dog.';
var words = str.split(' ');
console.log(words[3]);
// expected output: "fox"
var chars = str.split('');
console.log(chars[8]);
// expected output: "k"
var strCopy = str.split();
console.log(strCopy);
// expected output: Array ["The quick brown fox jumps over the lazy dog."] `}/>
      </code>
      </pre></td>
                            <td>Découpe une chaîne en un tableau à partir d'une RegExp</td>
                        </tr>
                        <tr>
                            <td>.toString()</td>
                            <td> <pre><code>
      <AceEditor
      height={calcHeight(10)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      mode="javascript"
      theme="monokai"
      value={`function Dog(name) {
this.name = name;
}
const dog1 = new Dog('Gabby');
Dog.prototype.toString = function dogToString() {
return this.name;
};
console.log(dog1.toString());
// expected output: "Gabby"</div>`}/>
      </code>
      </pre></td>
                            <td>Renvoie une chaîne de caractères représentant l'objet</td>
                        </tr>
                    </table>
  
      

      </div>
    )
}
